import React, { useState } from 'react';
import { useGetCacheClearStatusQuery } from '../urls/api/urlsApiSlice';
import { Button, Input, Typography, Flex, Alert } from 'antd';

enum CacheClearanceStatus {
  QUEUED = 'QUEUED',
  NOT_QUEUED = 'NOT_QUEUED',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  PROCESSING = 'PROCESSING',
}

type NewClearPartialCacheProps = {
  onClearPartialCacheClick: (wildcard: string) => void;
  urlsNotFound: boolean;
  setUrlsNotFound: (urlsNotFound: boolean) => void;
};

export const NewClearPartialCache: React.FC<NewClearPartialCacheProps> = ({
  onClearPartialCacheClick,
  urlsNotFound,
  setUrlsNotFound,
}) => {
  const [wildcard, setWildcard] = useState('');
  const statusData = useGetCacheClearStatusQuery({});

  const isNotQueued = statusData.data?.data?.status === CacheClearanceStatus.NOT_QUEUED;
  const showNotInQueuedAlert = statusData.isSuccess && !isNotQueued;

  const enableClearButton = wildcard != '' && isNotQueued;

  const onClearCacheButtonClick = () => {
    if (isNotQueued && wildcard != '') {
      onClearPartialCacheClick(wildcard);
    }
  };

  const onWildcardChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWildcard(event.target.value);
    setUrlsNotFound(false);
  };

  return (
    <>
      {showNotInQueuedAlert && (
        <Alert
          showIcon
          type="success"
          message="Clearing partial cache currently in progress."
          style={{ marginBottom: 16 }}
        />
      )}
      {statusData.isError && (
        <Alert showIcon type="error" message="Sorry, something went wrong" style={{ marginBottom: 16 }} />
      )}
      <Flex justify="start" style={{ paddingTop: 16 }}>
        <Typography.Text>
          To clear cache of specific URL(s), please type the <b>wildcard</b> to find URL(s) by.
        </Typography.Text>
      </Flex>
      <div style={{ paddingTop: 16 }}>
        <Flex justify="space-between" style={{ width: '100%' }} gap={16}>
          <Input
            type="text"
            id="delete-url-like"
            placeholder="for example: https://my-website.com/blog/*"
            value={wildcard}
            onChange={onWildcardChange}
            status={urlsNotFound ? 'error' : undefined}
          />
          <Button type="primary" onClick={onClearCacheButtonClick} disabled={!enableClearButton}>
            Clear Partial Cache...
          </Button>
        </Flex>
        {urlsNotFound && (
          <Typography.Text type="danger" style={{ display: 'block', marginTop: 8 }}>
            No URLs found matching this wildcard
          </Typography.Text>
        )}
      </div>
    </>
  );
};
